import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Dropdown from '~/components/CasesDropdown.vue';
import WebpPicture from '~/components/WebpPicture.vue';
export default {
  __name: 'HelpRoot',
  setup: function setup(__props) {
    var modalityStore = useModalityStore();
    var appStore = useAppStore();
    function openSubDd(payload, helpMenu, event) {
      event.preventDefault();
      event.stopPropagation();
      appStore.$patch({
        helpMenu: helpMenu
      });
      modalityStore.openDropdown(payload);
      modalityStore.dropdowns.forEach(function (dd) {
        if (dd.name !== payload.name) {
          modalityStore.closeDropdown({
            name: dd.name
          });
        }
      });
    }
    return {
      __sfc: true,
      modalityStore: modalityStore,
      appStore: appStore,
      openSubDd: openSubDd,
      Dropdown: Dropdown,
      WebpPicture: WebpPicture
    };
  }
};